import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { checkCBSEGr8, getSubIcon , checkIfNonScienceSubjectExists} from '@app-helpers/functions';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { HelperService } from 'src/app/core/services/helper.service';

import { cbseScienceGrade } from '@app-constants/app.constants';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { FirebaseAnalyticsService } from '@app-services/firebase-analytics/firebase-analytics.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.css']
})
export class CourseCardComponent implements OnInit {

  @Input() courseData: any;
  @Input() dataType: any;
  @Input() fromLiveClassPage: boolean;
  @Output() actionOnClick = new EventEmitter<any>();
  getSubIcon = getSubIcon;
  showScience: boolean = false;
  constructor(
    private _eventHandlingService: EventHandlingService,
    public _helper: HelperService,
    private firebaseService: FirebaseService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.showScience = checkCBSEGr8();
  }

  clickAction(type: string) {
    this._eventHandlingService.changeAction({ type: type, dataType: this.dataType, classData: this.courseData });
  }

  checkIfNonScienceSubjectExists(subjects){
    return checkIfNonScienceSubjectExists(subjects);
  }
  navigateToCourseDetails(id){
    // [routerLink]="['/course', courseData.id]"
    this.firebaseService.getFireBaseEventUserDetailsPromise(id).then((val:any)=>{
      let firebaseObj = {
        platform: val?.platform,
        grade: val?.grade,
        stream:val?.stream,
        board:val?.board,
        exams: val?.exams,
        exam: val?.exam,
        state:val?.state,
        city: val?.city,
        imageUrl:val?.imageUrl,
        courseName:val?.courseName,
        classLanguage:val?.language,
        subjects:val?.subjects,
      };
      this.firebaseAnalyticsService.postEvent("web_liveclass_cta_courseDetails_enrollNow",firebaseObj);
    this._router.navigate(['/course',id]);
    })
  }

}
